<template>
  <div>
    <div class="d-flex pdf-container bg-contentPlayerBg "
         style="height: calc(100vh - 132px); padding-top:64px; ">
      <div id="waterMarkInner" class="flex-grow-1 position-relative">
        <iframe id="pdfIfrem" :src="`/pdfjs/web/viewer.html?file=${pdfFileUrl}#zoom=90`" data-v-0ef8941c=""
                frameborder="0" height="100%" scrolling="0" width="100%">
        </iframe>
        <span class="waterMarkInner">
        <span class="t-headline7 t-color-whiteSelected t-center mgb-16">{{
            personalInfo ? personalInfo.userId : ''
          }}</span>
        <span class="t-headline7 t-color-blackHover t-center">{{ personalInfo ? personalInfo.userId : '' }}</span>
      </span>
      </div>
      <div v-if="isLearningObjective" :class="lightModeActive ? 'bg-documentGray' : ''"
           class="description-sidebar t-color-white ">
        <div :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'"
             class="pdt-27 pdb-26 pdl-24 pdr-24 sidebarHeader-slide position-relative">
          <div class="position-abosolute d-flex justify-content-between align-items-center ">
            <div :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" class="t-subtitle3 font-m paging">
              {{ $t('1046') }}
            </div>
            <div class="d-flex align-items-center">
              <a :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" class="closebtn pdt-4"
                 href="javascript:void(0)" tabindex="0"
                 @click="setisLearningObjective" @keypress="setisLearningObjective">
                <i class="material-icons w-22 ">close</i>
              </a>
            </div>
          </div>
        </div>
        <div class="pdl-24 pdr-24 t-color-whiteHigh2 font-r t-body1 t-line-h-28 pdt-20">
          <span class="pdb-32">{{ learnPurposes }}</span>
        </div>
      </div>
      <div v-if="isResources" :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'"
           class="learning-material-sidebar t-color-white">
        <div :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'"
             class="pdt-27 pdb-27 pdr-24 pdl-24 sidebarHeader-slide position-relative">
          <div class="position-abosolute d-flex justify-content-between align-items-center ">
            <div :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" class="t-subtitle3 font-m paging">
              {{ $t('1046') }}
            </div>
            <div class="d-flex align-items-center">
              <a :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" class="closebtn pdt-4"
                 href="javascript:void(0)" tabindex="0" @click="setisResources" @keypress="setisResources">
                <i class="material-icons w-22 ">close</i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-footer">
      <div class="range-slider range-slider__range">
        <div :style="`width:${progressBar}%;`" class="home-progressbar video-status position-absolute"></div>
      </div>
      <div v-if="lightModeActive" class="divider"></div>
      <div :class="lightModeActive ? '':'bg-contentPlayerBg'" class="d-flex justify-content-between  footer-learning ">
        <div class="pdl-50 pdt-4 d-flex align-items-center">
							<span tabindex="0" @click="darkModeToLight()" @keypress="darkModeToLight()">
							<img :src="lightModeActive?'/img/lightModeFixedButton.png':'/img/darkModeFixedButton.svg'"
                   alt="mode control" class="cursor-pointer w-32 h-32">
							</span>
          <span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>

          <span :class="zoomPercentCustom<=10?'disAbledPlusAndMinus':''" class="cursor-pointer" tabindex="0"
                @click="zoomOut" @keypress="zoomOut"><img :src="lightModeActive ? '/img/zoon-minus-light.png': '/img/zoon-minus.png'"
                                      alt="zoom view minus" class="w-32 h-32"></span>

          <span class="pdl-24 t-color-whiteHigh t-subtitle5 pdr-24 t-nowrap"> {{ zoomPercentCustom }}% </span>
          <span :class="zoomPercentCustom>=300?'disAbledPlusAndMinus':''" class="cursor-pointer" tabindex="0"
                @click="zoomIn" @keypress="zoomIn"><img :src="lightModeActive ? '/img/zoom-plus-light.png':'/img/zoom-plus.png'"
                                     alt="zoom view plus" class="w-32 h-32"></span>
          <span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24 t-nowrap"></span>
          <span class="cursor-pointer" tabindex="0" @click="presentationMode()" @keypress="presentationMode()"><img
              :src="lightModeActive ? '/img/fit-to-page-light.png' : '/img/fit-to-page.png'" alt="fit to page"
              class="w-32 h-32 mgr-24"></span>
          <span class="cursor-pointer"><img
              :src="lightModeActive ? '/img/fit-to-scroll-active-light.svg':'/img/fit-to-scroll-active.svg'"
              alt="full scren view" class="w-32 h-32"></span>
          <span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>
          <span class="cursor-pointer" tabindex="0" @click="scrollHorizontal" @keypress="scrollHorizontal">
								<img v-if="isVertical" :src="lightModeActive ? '/img/arrow-h-light.png': '/img/arrow-h.png'"
                     alt="align horizontal" class="w-32 h-32 mgr-24">
								<img v-else
                     :src="lightModeActive ? '/img/arrow-h-active-light.png' : '/img/arrow-h-active.png'"
                     alt="align horizontal" class="w-32 h-32 mgr-24">
							</span>
          <span class="cursor-pointer" tabindex="0" @click="scrollVertical" @keypress="scrollVertical">
								<img v-if="isVertical"
                     :src="lightModeActive ? '/img/arrow-v-active-light.png':'/img/arrow-v-active.png'"
                     alt="align vertical" class="w-32 h-32 ">
								<img v-else :src="lightModeActive ? '/img/arrow-v.png' : '/img/arrow-v.png'" alt="align vertical"
                     class="w-32 h-32">
							</span>
          <span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>

        </div>
        <div class="d-flex align-items-center justify-content-center pdt-4 footer-center-absolute">
          <div class="t-color-whiteHigh t-subtitle5 mgl-8"> {{ pdfPagenumber }}</div>
          <div class="t-color-whiteMedium t-body7 mgl-8 t-nowrap"> / {{ pdfTotalpage }}</div>
        </div>
        <div class="d-flex align-items-center pdt-4 justify-content-end mgr-50">
          <div class="d-flex align-items-center">
            <button
                :class="likes ? 't-color-red' : 't-color-whiteDisabled'"
                class="material-icons mdc-icon-button  mgl--12 l-icon"
                tabindex="0"
                @click="onLike" @keypress="onLike">favorite
            </button>
            <span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ likesCount }}</span>
          </div>
          <div class="d-flex align-items-center mgl-24 mgr-24">
            <button
                :class="clipping ? 't-color-contentBlue' : 't-color-whiteDisabled'"
                class="material-icons mdc-icon-button  mgl--12 l-icon"
                @click="onBookmark" @keypress="onBookmark">bookmark
            </button>
            <span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ clippingCount }}</span>
          </div>
          <span class="cursor-pointer"><img :src="lightModeActive ? '/img/information-light.png':'/img/information.png'"
                                            alt="information" class="l-icon" tabindex="0"
                                            @click="setisLearningObjective" @keypress="setisLearningObjective"></span>
          <span class="cursor-pointer"><img :src="lightModeActive?'/img/list-icon-light.svg':'/img/list-icon.svg'"
                                            alt="index" class="l-icon mgl-24 mgr-24  rtl-support" tabindex="0"
                                            @click="sidebarToggle()" @keypress="sidebarToggle()"></span>
          <button :class=" lightModeActive  ? 'bg-contentPlayerBgLight' : 'bg-secondaryBtn'"
                  class="mdc-button mdc-button--raised t-color-contentText min-w-auto"
                  tabindex="0"
                  @click="setisQuestionAns()" @keypress="setisQuestionAns()">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r t-nowrap">{{ $t('3184') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {slideTypeMixins} from '@/mixins/slideType.js'

export default {
  name: "PdfType2",

  props: ['personalInfo', 'lightModeActive', 'lessonDataObj'],

  components: {},

  mixins: [slideTypeMixins],

  data() {
    return {
      pdfFileUrl: this.lessonDataObj.pdf.file,
      isVertical: true,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,
      learnPurposes: "",
      pdfPagenumber: 0,
      pdfTotalpage: 0,
      progressBar: 0,
      zoomPercentCustom: 90,
    }
  },

  watch: {
    // set total number of page
    pdfPagenumber: function () {
      let addClassIndex = document.getElementById("pdfIfrem").contentWindow.document.getElementById("toolbarSidebar");
      let addClassIndexCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("thumbnailView");
      let addClassIndexTextCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("indexTextColor");
      let addClassIndexCloseCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("indexCloseColor");
      addClassIndex.classList.remove("cssClass")
      addClassIndexCard.classList.remove("cssClass")
      addClassIndexTextCard.classList.remove("cssClass")
      addClassIndexTextCard.classList = "t-body6 font-r paging"
      addClassIndexCloseCard.classList.remove("cssClass")
      // vertical scroll
      if (this.isVertical === true) {
        setTimeout(() => {
          document.getElementById("pdfIfrem").contentWindow.document.getElementById("scrollVertical").click()
          this.scrollVertical()
        }, 500);
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.pdfInterval);
  },

  mounted() {
    this.pdfIframeInit();
    this.setMaterialUi();

    window.onpopstate = function (event) {
      this.moveLearnViewClose()
    };
  },

  methods: {
    pdfIframeInit() {
      this.pdfIfrem = document.getElementById("pdfIfrem");

      this.pdfInterval = setInterval(() => {
        this.pdfZoomPecent = document.getElementById("pdfIfrem").contentWindow.document.getElementById("customScaleOption") ? document.getElementById("pdfIfrem").contentWindow.document.getElementById("customScaleOption").innerHTML : ''
        this.pdfPagenumber = document.getElementById("pdfIfrem").contentWindow.document.getElementById("pageNumber").value;
        let x = document.getElementById("pdfIfrem").contentWindow.document.getElementById("numPages").innerHTML;
        this.pdfTotalpage = x.split(' ')[1];
      }, 1000);
    },

    setMaterialUi() {
      this.$emit('setMaterialUi');
    },

    darkModeToLight() {
      this.$emit('darkModeToLight');
    },

    zoomOut() {
      this.pdfIfrem.contentWindow.document.getElementById("zoomOut").click();
      this.pdfZoomPecent1 = this.pdfIfrem.contentWindow.document.getElementById("customScaleOption").innerHTML;
      let zoonPer = parseInt(this.zoomPercentCustom) - 10;
      if (zoonPer < 10) {
        this.zoomPercentCustom = 10;
      } else {
        this.zoomPercentCustom = zoonPer;
      }
    },

    zoomIn() {
      this.pdfIfrem.contentWindow.document.getElementById("zoomIn").click();
      this.pdfZoomPecent1 = this.pdfIfrem.contentWindow.document.getElementById("customScaleOption").innerHTML;
      let zoonPer = parseInt(this.zoomPercentCustom) + 10;
      if (zoonPer >= 300) {
        this.zoomPercentCustom = 300;
      } else {
        this.zoomPercentCustom = zoonPer;
      }
    },

    presentationMode() {
      this.isVertical = true;
      document.getElementById("waterMarkInner").requestFullscreen();
      this.pdfIfrem.contentWindow.document.getElementById("scrollVertical").click();
      this.pdfIfrem.contentWindow.document.getElementById("presentationMode").click();
    },

    scrollHorizontal() {
      this.isVertical = false;
      this.pdfIfrem.contentWindow.document.getElementById("scrollHorizontal").click();
      document.getElementById("pdfIfrem").contentWindow.PDFViewerApplication.page = this.last;
    },

    // scroll pdf vertical
    scrollVertical() {
      this.isVertical = true;
      this.pdfIfrem.contentWindow.document.getElementById("scrollVertical").click();
    },

    onLike() {
      this.$emit('onLike');
    },

    onBookmark() {
      this.$emit('onBookMark');
    },

    sidebarToggle() {
      if (this.isQuestionAns === true) {
        this.isQuestionAns = false
      }
      if (this.isLearningObjective === true) {
        this.isLearningObjective = false
      }
      if (this.isResources === true) {
        this.isResources = false
      }

      this.pdfIfrem.contentWindow.document.getElementById("sidebarToggle").click();

      let addClassIndex = document.getElementById("pdfIfrem").contentWindow.document.getElementById("toolbarSidebar");
      let addClassIndexCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("thumbnailView");
      if (this.lightModeActive === true) {
        addClassIndex.className = 'cssClass';
        addClassIndexCard.className = 'cssClass';
      } else {
        addClassIndex.classList.remove("cssClass")
        addClassIndexCard.classList.remove("cssClass")
      }
    },
  }

}
</script>

<style scoped>

.disAbledPlusAndMinus {
  opacity: 0.5;
  cursor: none;
}

.waterMarkInner {
  top: 50%;
  z-index: 88;
  left: 50%;
  display: inline-block;
  position: absolute;
  transform: translate(-50%, -50%);
}

.waterMarkInner span {
  font-size: 4vw;
  line-height: 1;
  opacity: 0.3;
  transform: rotate(-23deg);
  font-weight: 800;
  user-select: none;
  padding-bottom: 5px;
  display: inline-block;
}

.footer-center-absolute {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

html[dir="rtl"] .footer-center-absolute {
  right: 50%;
}
</style>